export const CLIENT_LOGOS = [
  {
    src: '/images/clients/trusting-client-logos.svg',
    alt: 'Trusting Client Logos 1',
    width: 300,
    height: 38,
  },
]

export const LOGO_DURATION_SECONDS = 25
export const LOGO_HEIGHT = 300
